import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { ShiftInfo } from "@/pages/mill/gantt/models/ShiftInfo";

export const getM1TrendingData = async (
	params: {
		start: Date | undefined;
		end: Date | undefined;
		assetId: number | undefined;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Start", value: params.start?.toISOString() ?? null },
		{ name: "End", value: params.end?.toISOString() ?? null },
		{ name: "AssetId", value: params.assetId ?? null },
	];

	const resp = await apiService.callV2(
		"[M1].[GetTrendingData]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", null) as ShiftInfo[];
	}
	throw new Error(resp.message || "Error fetching M1 trending data");
};
